module.exports = __webpack_public_path__ + "static/media/img_taiwan.99863ecc.jpg";